module.exports = __webpack_public_path__ + "static/media/FTP.215071a6.pdf";